import {connect} from '../../../app/connect';
import IssuesPermissionsTable from './IssuesPermissionsTable';

import {
  getIssuesPermissions,
  isFetchingPermissions,
  getIssuesPermissionsFetchError,
  isDeletingPermissions
} from '../../../app/selectors';
import {updateIssuesPermissions, deleteIssuesPermissionsEntry, showNotificationAction} from '../../../app/actions';

const mapStateToProps = state => ({
  permissions: getIssuesPermissions(state),
  isFetchingPermissions: isFetchingPermissions(state),
  permissionsApiError: !!getIssuesPermissionsFetchError(state),
  isDeletingEntry: isDeletingPermissions(state)
});

const mapDispatchToProps = {
  updateIssuesPermissions,
  deleteIssuesPermissionsEntry,
  showNotificationAction
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(IssuesPermissionsTable);
